const AnimatedHeroCopy = {
  parts: [
    'container',
    'wrapper',
    'text'
  ],
  baseStyle: {
    container: {
      px: {base: 5, lg: 20},
      py: {base: 5, lg: 20},
      maxWidth: '1440px',
      mx: 'auto',
    },
    wrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      maxWidth: '839px',
      mx: 'auto',
      px: {base: 8, lg: 0},
    },
    text: {
      color: 'brandColors.greyscale90',
      textAlign: 'center',
      fontSize: {base: 'lg', lg: '32px'},
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: '150%',
    },
  },
};

export default AnimatedHeroCopy;
